
import React, { Component } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableListSort from 'core/TableListSort';
import MenuItem from '@material-ui/core/MenuItem';
import { ButtonMenu } from 'ui/ButtonMenu';


export class TariffListTable extends Component {

  disableClickEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const { items, onDetail, onAddAndCopy } = this.props;

    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell className={'hide-on-mobile'}>
              <TableListSort label={'Номер'} name={'id'} />
            </TableCell>
            <TableCell>Название</TableCell>
            <TableCell>
              <TableListSort label={'Тип'} name={'polymorphic_ctype'} />
            </TableCell>
            <TableCell>
              <TableListSort label={'Перевозчик'} name={'carrier'} />
            </TableCell>
            <TableCell className={'w-100'}>НДС</TableCell>
            <TableCell className={'w-50'} />
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(tariff =>
          <TableRow
            className={'pointer'}
            key={tariff.id}
            hover={true}
            onClick={() => onDetail(tariff)}
          >
            <TableCell className={'hide-on-mobile'}>{tariff.id}</TableCell>
            <TableCell>{tariff.name}</TableCell>
            <TableCell>{tariff.type_display}</TableCell>
            <TableCell>
              {tariff.carrier__name}
            </TableCell>
            <TableCell>
              {tariff.vat_display}
            </TableCell>
            <TableCell className={'disable-click'} onClick={(e) => this.disableClickEvent(e)}>
              {tariff.resourcetype === 'TariffBase' && (
                <ButtonMenu label={'...'} size={'small'}>
                  <MenuItem onClick={() => onAddAndCopy(tariff)}>Копировать</MenuItem>
                </ButtonMenu>
              )}
            </TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
